import { BaseModel } from "@/models/base";
import { API_CPV_AUTH_URL, API_CPV_URL } from "@/commons/config";
import { handleErrorResponse, handleResponse } from "@/helpers/handle-response";
import { Axios } from "axios-observable";
import { AxiosResponse, AxiosRequestConfig } from "axios";
import { cpvHandleRequest , cpvHandleErrorRequest } from "@/helpers/cpv-handle-request";

export interface APIModel<T extends BaseModel> {
  body?: T;
  pageIndex?: number;
  pageSize?: number;
}

export class cpvBaseAPI<T extends BaseModel> {
    protected axios: Axios;
    protected cpvAuthAPIUrl: string;
    protected cpvVereadorAPIUrl: string;
    protected cpvCamaraAPIUrl: string;
    protected cpvVeiculoAPIUrl: string;


    constructor() {
      this.axios = this.buildAxiosInstance();
      this.cpvAuthAPIUrl = API_CPV_AUTH_URL;
      this.cpvVereadorAPIUrl = API_CPV_URL;
      this.cpvCamaraAPIUrl = API_CPV_URL;
      this.cpvVeiculoAPIUrl = API_CPV_URL;
    }


    private buildAxiosInstance(): Axios {
      const axiosInstance = Axios.create({});
      this.requestInterceptor(axiosInstance);
      this.responseInterceptor(axiosInstance);

      return axiosInstance;
    }

    private requestInterceptor(axios: Axios): void {
      axios.interceptors.request.use(
        (config: AxiosRequestConfig) => cpvHandleRequest(config),
        (error: any) => cpvHandleErrorRequest(error)
      );
    }

    private responseInterceptor(axios: Axios): void {
      axios.interceptors.response.use(
        (response: AxiosResponse) => handleResponse(response),
        (error: any) => handleErrorResponse(error)
      );
    }
}
